// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStrengthMeter-ErrorIcon_cls1__3yIDG","cls2":"VeloStrengthMeter-ErrorIcon_cls2__abxsz VeloStrengthMeter-ErrorIcon_cls1__3yIDG"};